import { trace } from 'rytm-helpers'

export const initFullScreen = () => {
  // toggle fullscreen listener
  document.documentElement.addEventListener("click", onDocClick)

  // listen to fullcreenchange
  document.addEventListener("fullscreenchange", (event) => {
    if (document.fullscreenElement) {
      // trace("Entering fullscreen")
      document.body.classList.add("full-screen-mode-on")
    } else {
      // trace("Leaving fullscreen")
      document.body.classList.remove("full-screen-mode-on")
    }
  }); 

}

const onDocClick = (e) => {
  if (e.target?.classList?.contains("fullscreen-toggle")) {
    e.preventDefault();
    if (document.body.classList.contains("full-screen-mode-on")) {
      closeFullscreen()
    } else {
      openFullscreen()
    }
  }
}

const openFullscreen = () => {
  if (document.documentElement.requestFullscreen) {
    document.documentElement.requestFullscreen();
  } else if (document.documentElement.webkitRequestFullscreen) { /* Safari */
    document.documentElement.webkitRequestFullscreen();
  } else if (document.documentElement.msRequestFullscreen) { /* IE11 */
    document.documentElement.msRequestFullscreen();
  }
}
const closeFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) { /* Safari */
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) { /* IE11 */
    document.msExitFullscreen();
  }
}